//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './TestApiClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';




export function deleteTenantUrl(): string {
  let url_ = getBaseUrl() + "/api/test/tenant";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deleteTenantMutationKey(): MutationKey {
  return trimArrayEnd([
      'TestApiClient',
      'deleteTenant',
    ]);
}

export function useDeleteTenantMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = deleteTenantMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.deleteTenant(),
    mutationKey: key,
  });
}
  
export function resetTenantUrl(): string {
  let url_ = getBaseUrl() + "/api/test/tenant/reset";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function resetTenantMutationKey(): MutationKey {
  return trimArrayEnd([
      'TestApiClient',
      'resetTenant',
    ]);
}

export function useResetTenantMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = resetTenantMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.resetTenant(),
    mutationKey: key,
  });
}
  
export function resetPatientsUrl(): string {
  let url_ = getBaseUrl() + "/api/test/tenant/reset-patients";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function resetPatientsMutationKey(): MutationKey {
  return trimArrayEnd([
      'TestApiClient',
      'resetPatients',
    ]);
}

export function useResetPatientsMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = resetPatientsMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.resetPatients(),
    mutationKey: key,
  });
}
  
export function dateTimeSerializationUrl(): string {
  let url_ = getBaseUrl() + "/api/test/datetime-serialization";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function dateTimeSerializationMutationKey(): MutationKey {
  return trimArrayEnd([
      'TestApiClient',
      'dateTimeSerialization',
    ]);
}

export function useDateTimeSerializationMutation<TContext>(options?: Omit<UseMutationOptions<Types.DateTimeSerializationDto, unknown, Types.DateTimeSerializationDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.DateTimeSerializationDto, unknown, Types.DateTimeSerializationDto, TContext> {
  const key = dateTimeSerializationMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.DateTimeSerializationDto) => Client.dateTimeSerialization(dto),
    mutationKey: key,
  });
}
  
export function signalRClientDeclarationsUrl(): string {
  let url_ = getBaseUrl() + "/api/test/signalr-client-declarations";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function signalRClientDeclarationsMutationKey(): MutationKey {
  return trimArrayEnd([
      'TestApiClient',
      'signalRClientDeclarations',
    ]);
}

/**
 * This method exists so that SignalR types are generated on the frontend and could be used when
parsing SignalR messages
 */
export function useSignalRClientDeclarationsMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.NotificationDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.NotificationDto, TContext> {
  const key = signalRClientDeclarationsMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (notificationDto: Types.NotificationDto) => Client.signalRClientDeclarations(notificationDto),
    mutationKey: key,
  });
}
  
export function throwErrorGETUrl(): string {
  let url_ = getBaseUrl() + "/api/test/error-test";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let throwErrorGETDefaultOptions: Omit<UseQueryOptions<string, unknown, string>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<string, unknown, string>, 'queryFn'>> = {
};
export function getThrowErrorGETDefaultOptions() {
  return throwErrorGETDefaultOptions;
};
export function setThrowErrorGETDefaultOptions(options: typeof throwErrorGETDefaultOptions) {
  throwErrorGETDefaultOptions = options;
}

export function throwErrorGETQueryKey(): QueryKey;
export function throwErrorGETQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'TestApiClient',
      'throwErrorGET',
    ]);
}
export function __throwErrorGET(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.throwErrorGET(
axiosConfig    );
}

/**
 * Demonstrates an error response.
 */
export function useThrowErrorGETQuery<TSelectData = string, TError = unknown>(options?: Omit<UseQueryOptions<string, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useThrowErrorGETQuery<TSelectData = string, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<string, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<string, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __throwErrorGET(context, axiosConfig) : __throwErrorGET,
    queryKey: throwErrorGETQueryKey(),
    ...throwErrorGETDefaultOptions as unknown as Omit<UseQueryOptions<string, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Demonstrates an error response.
 */
export function setThrowErrorGETData(queryClient: QueryClient, updater: (data: string | undefined) => string, ) {
  queryClient.setQueryData(throwErrorGETQueryKey(),
    updater
  );
}

/**
 * Demonstrates an error response.
 */
export function setThrowErrorGETDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: string | undefined) => string) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function throwErrorPOSTUrl(): string {
  let url_ = getBaseUrl() + "/api/test/error-test";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function throwErrorPOSTMutationKey(): MutationKey {
  return trimArrayEnd([
      'TestApiClient',
      'throwErrorPOST',
    ]);
}

/**
 * Demonstrates an error response.
 */
export function useThrowErrorPOSTMutation<TContext>(options?: Omit<UseMutationOptions<string, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<string, unknown, void, TContext> {
  const key = throwErrorPOSTMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.throwErrorPOST(),
    mutationKey: key,
  });
}